import { createElementVNode as _createElementVNode, renderSlot as _renderSlot, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "all" }
const _hoisted_2 = { class: "contents" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(["menu", { 'is-display': !_ctx.isDisplay }])
    }, [
      _cache[0] || (_cache[0] = _createElementVNode("div", { class: "gradient" }, null, -1)),
      _renderSlot(_ctx.$slots, "menu", {}, undefined, true)
    ], 2),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        class: _normalizeClass(["login-container", {
                    wide: _ctx.isWide,
                    'not-padding': _ctx.isPadding,
                    wide770: _ctx.isWide770,
                    wide900: _ctx.isWide900,
                    wide1200: _ctx.isWide1200,
                    'sp-change-padding': _ctx.isChangeSpPadding,
                }])
      }, [
        _renderSlot(_ctx.$slots, "contents", {}, undefined, true)
      ], 2)
    ])
  ]))
}